import React, { useEffect, useState } from 'react';
import AdminLayout from '@/components/AdminLayout';
import { api } from '@/lib/api';

export default function AdminMalls() {
    const [malls, setMalls] = useState([]);
    useEffect(() => { api.get('/admin/malls').then(({ data }) => setMalls(data)); }, []);

    return (
        <AdminLayout>
            <div className="p-10" data-testid="admin-malls-page">
                <div className="overline">Malls</div>
                <h1 className="font-serif text-4xl text-navy mt-2 mb-8">All Inorbit Malls</h1>
                <div className="grid md:grid-cols-2 gap-6">
                    {malls.map((m) => (
                        <div key={m.id} className="bg-white border border-border-subtle p-6 flex gap-6" data-testid={`admin-mall-${m.slug}`}>
                            <img src={m.hero_image} alt={m.name} className="w-32 h-32 object-cover shrink-0" />
                            <div className="flex-1">
                                <div className="font-serif text-2xl text-navy">{m.name}</div>
                                <div className="text-xs text-gold mb-2">{m.tagline}</div>
                                <div className="text-xs text-text-tertiary">{m.address}</div>
                                <div className="mt-3 grid grid-cols-2 gap-2 text-sm">
                                    <div>Brands: <span className="font-semibold text-navy">{m.brand_count}</span></div>
                                    <div>Area: <span className="font-semibold text-navy">{m.area_sqft.toLocaleString('en-IN')} sqft</span></div>
                                    <div>Floors: <span className="font-semibold text-navy">{m.floors}</span></div>
                                    <div>Status: <span className="font-semibold text-emerald-700">{m.is_active ? 'Active' : 'Inactive'}</span></div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </AdminLayout>
    );
}
